import React, { MouseEvent } from 'react';
import { Channel } from 'talkplus-sdk/dist/model/types';
import Icon from '@common/assets';
import Image from '@common/image';
import { RowWritingMotion } from '@components/profile/common/writingMotion';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const Hour = 1000 * 60 * 60;

interface ChatListItemProps {
  channel: Channel | null;
  messageVisible?: boolean;
  isNotifying?: boolean;
  isMenu?: boolean;
  onClick: () => void;
  onClickMenu?: (event: MouseEvent<HTMLElement>) => void;
}

const ChatListItem = ({
  channel,
  messageVisible,
  isNotifying = true,
  isMenu,
  onClick,
  onClickMenu,
}: ChatListItemProps) => {
  const getMemberCount = () => {
    const count = channel?.memberCount || 0;
    return count > 0 ? count : 0;
  };

  const getContentsEl = () => {
    const createdAt = new Date(channel?.createdAt || new Date()).getTime();
    const updatedAt = new Date(channel?.lastSentAt || new Date()).getTime();
    const now = new Date().getTime();
    const isWriting = createdAt === updatedAt ? false : (now - updatedAt) / Hour <= 1;
    const text = channel?.lastMessage?.text;

    if (channel?.lastMessage?.type === 'admin') return null;
    if (!text) return null;
    if (isWriting)
      return (
        <div className={cx('motionWrap')}>
          <RowWritingMotion />
        </div>
      );
    return (
      <div className={cx('contentsWrap')}>
        <span className={cx('contents')}>{text}</span>
      </div>
    );
  };

  const handleClick = () => {
    onClick();
  };

  const handleClickMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClickMenu?.(e);
  };

  if (!channel) return null;

  return (
    <li className={cx('itemArea')} onClick={handleClick}>
      <div className={cx('itemWrap')}>
        <div className={cx('imgArea')}>
          {channel.imageUrl ? (
            <Image alt={'logo'} className={cx('img')} src={channel.imageUrl} width={40} height={40} />
          ) : (
            <Icon name="logo" width={32} height={7} fill={Colors.C_COOL_GRAY_50} />
          )}
        </div>
        <div className={cx('contentsArea')}>
          <div className={cx('nameWrap')}>
            <span className={cx('companyName')}>{channel.name}</span>
            <span className={cx('number')}>
              ({getMemberCount()}명)
              {!isNotifying && (
                <div className={cx('iconArea')}>
                  <Icon name="bellOffLight" width={20} height={20} fill={Colors.C_COOL_GRAY_70} />
                </div>
              )}
            </span>
          </div>
          {messageVisible && getContentsEl()}
        </div>
      </div>
      {isMenu && (
        <button className={cx('menuBtn')} onClick={handleClickMenu}>
          <Icon name="moreHorizonLight" width={32} height={32} />
        </button>
      )}
    </li>
  );
};

export default ChatListItem;
